import { Outlet } from "react-router-dom";
import "./app/globals.css";
import { ThemeProvider } from "@/components/ThemeProvider";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import LayoutContent from "@/components/LayoutContent";
import Analytics from "@/components/Analytics";

export default function RootLayout() {
  return (
    <ThemeProvider attribute="class" defaultTheme="dark" enableSystem>
      <LayoutContent>
        <Header />
        <Outlet />
        <Footer />
        <Analytics />
      </LayoutContent>
    </ThemeProvider>
  );
}
